var NewsSearch = {
    newsResultsPerPage: 9,
    newsRootId: 0,
    newsCurrentResultPage: 1,
    SearchType: "",
    searchTerm: "",
    docType: "newsArticle",
    partialView: "NewsResult_Rows",
    newsResultTarget: null,
    fallbackImageId: "",

    InitNewsSearch: function (_fallbackImageId, _rootId, hasSearchTerm, _itemsPerPage, _renderPartial) {
        document.querySelectorAll('.newsSortButton').forEach(function (button) {
            button.addEventListener("click", function (e) {
                var sortType = e.target.dataset.sortType;

                this.DoSearch(sortType);
            }.bind(this));
        }.bind(this));

        this.newsResultsPerPage = _itemsPerPage;
        this.newsRootId = _rootId;
        this.newsResultTarget = document.querySelector('#nextPageOfResults');
        this.SearchType = "NewsSearch";
        this.fallbackImageId = _fallbackImageId;
        if (isEmptyOrSpaces(_renderPartial)) {
            alert('Need to pass in the partial name that will render the result');
            return;
        }
        this.renderPartial = _renderPartial;

        if (_itemsPerPage !== undefined && _itemsPerPage !== null && parseInt(_itemsPerPage) > 0) {
            this.itemsPerPage = parseInt(_itemsPerPage);
        }


        if (hasSearchTerm === true) {
            this.initialSearch = false;  // Prevent a keyword from the query string from being overwritten
        }

        document.querySelectorAll('.search__aggregation input[type=checkbox]').forEach(function (key) {
            key.addEventListener("change", function (e) {
                e.preventDefault();
                this.DoSearch();
            }.bind(this));
        }.bind(this));

        document.querySelector("#clearFilters").addEventListener("click", function () {
            this.ClearFilters();
        }.bind(this));

        document.querySelector("#clearSearch").addEventListener("click", function () {
            this.ClearSiteSearch();
        }.bind(this));

        document.querySelector("#searchFieldInput").nextElementSibling.addEventListener("click", function (event) {
            event.preventDefault();
            var searchText = document.querySelector("#searchFieldInput").value;
            // don't bother searching if it's the same as last time
            if (searchText !== this.searchTerm) {
                this.DoAjaxSearch(1);

                this.searchTerm = searchText;
                var searchTextEl = document.getElementById("searchResultsText");
                if (searchText && searchText.length > 0) {
                    // show search result text in sidebar
                    searchTextEl.classList.remove("hidden");
                    searchTextEl.querySelector("span").textContent = document.querySelector("#searchFieldInput").value;
                    // show clear search button
                    document.getElementById("clearSearch").classList.remove("hidden");
                } else {
                    searchTextEl.classList.add("hidden");
                    document.getElementById("clearSearch").classList.add("hidden");
                }
            }
        }.bind(this));


        // Add events for checkboxes
        document.querySelectorAll(".customFilter").forEach(function (checkbox) {
            checkbox.addEventListener("change", function () {
                // show active filter area
                if (checkbox.checked) {
                    // show active filters
                    document.getElementById("activeFilters").classList.remove("hidden");

                    // add item to active filters
                    var labelText = checkbox.nextElementSibling.textContent;
                    var li = document.createElement("li");
                    li.setAttribute("data-filter-id", checkbox.id);
                    var activeFilterItem = document.createElement("button");
                    activeFilterItem.textContent = labelText;
                    activeFilterItem.classList.add("tag", "tag--filter", "button", "button--text");
                    activeFilterItem.title = "Remove filter";
                    var icon = document.createElement("i");
                    icon.classList.add("icon", "icon--close");
                    icon.setAttribute("aria-hidden", "true");
                    activeFilterItem.appendChild(icon);
                    li.appendChild(activeFilterItem);
                    document.getElementById("activeFilterList").appendChild(li);

                    li.addEventListener("click", function () {
                        // uncheck filter checkbox
                        checkbox.checked = false;
                        li.remove();
                        if (document.querySelectorAll(".customFilter:checked").length === 0) {
                            // hide active filters
                            document.getElementById("activeFilters").classList.add("hidden");
                        }
                        this.DoAjaxSearch(1);
                    }.bind(this));
                } else {
                    // remove item from active filters
                    document.getElementById("activeFilterList").querySelector("[data-filter-id='" + checkbox.id + "'").remove();

                    if (document.querySelectorAll(".customFilter:checked").length === 0) {
                        // hide active filters
                        document.getElementById("activeFilters").classList.add("hidden");
                    }
                }
                this.DoAjaxSearch(1);
            }.bind(this));
        }.bind(this));


        var pageNumber = 1;
        if (window.location.hash && window.location.hash.split('-').pop()) {
            pageNumber = window.location.hash.split('-').pop();
        }
        var prom = this.GetSearchResults(pageNumber);
        prom.then(
            function (result) {
                // console.log("Search results : %o", result);
                if (result.sortType === 'alphabetical') {
                    var initialSortButton = document.querySelector("[data-sort-type='displayDateIndex']");
                    initialSortButton.removeAttribute("aria-current");
                    var alphabeticalSortButton = document.querySelector("[data-sort-type='alphabetical']");
                    alphabeticalSortButton.setAttribute("aria-current", "page");
                } else {
                    var initialSortButton = document.querySelector("[data-sort-type='displayDateIndex']");
                    initialSortButton.setAttribute("aria-current", "page");
                    var alphabeticalSortButton = document.querySelector("[data-sort-type='alphabetical']");
                    alphabeticalSortButton.removeAttribute("aria-current");
                }

                $('#nextPageOfResults').html(result.htmlResults);

                $('.pagination-target').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.itemsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        this.DoAjaxSearch(pageNumber);

                        document.getElementById("topOfSearch").scrollIntoView();
                    }.bind(this),
                    onInit: function () {

                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }

                        this.DoPagination(resultCount, pageNumber);
                    }.bind(this)
                });
            }.bind(this)
        );
    },

    ClearSiteSearch: function () {
        document.getElementById("searchFieldInput").value = "";
        document.getElementById("searchResultsText").classList.add("hidden");
        document.getElementById("clearSearch").classList.add("hidden");
        this.searchTerm = "";
        this.DoAjaxSearch(1);
    },

    ClearFilters: function () {
        // remove all items from active filter list
        document.getElementById("activeFilterList").innerHTML = "";

        // Uncheck all the boxes
        document.querySelectorAll(".customFilter").forEach((checkbox) => {
            checkbox.checked = false;
        });

        // hide active filters
        document.getElementById("activeFilters").classList.add("hidden");


        this.DoAjaxSearch(1);
    },

    DoSearch: function (sortType = 'displayDateIndex') {
        // reset url since we're always on page 1
        let prom = this.GetSearchResults(1, this.newsRootId, sortType);

        prom.then(
            function (result) {
                if (result.sortType === 'alphabetical') {
                    var initialSortButton = document.querySelector("[data-sort-type='displayDateIndex']");
                    initialSortButton.removeAttribute("aria-current");
                    var alphabeticalSortButton = document.querySelector("[data-sort-type='alphabetical']");
                    alphabeticalSortButton.setAttribute("aria-current", "page");
                } else {
                    var initialSortButton = document.querySelector("[data-sort-type='displayDateIndex']");
                    initialSortButton.setAttribute("aria-current", "page");
                    var alphabeticalSortButton = document.querySelector("[data-sort-type='alphabetical']");
                    alphabeticalSortButton.removeAttribute("aria-current");
                }

                this.DoPagination(result.totalResultCount, 1);


                this.newsResultTarget.innerHTML = result.htmlResults;
                this.newsCurrentResultPage++;
            }.bind(this)   // Bind the parent scope to this
        );
    },

    DoPagination: function (resultCount, currentPage) {
        var $pagination = $('.pagination-target');

        //  console.log('Page results count : %o - Per page : %o', resultCount, this.itemsPerPage);

        if (resultCount !== null && resultCount > this.itemsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },
    DoAjaxSearch: function (pageNo) {
        var activeSortButton = document.querySelector(".newsSortButton[aria-current='page']");
        var sortType = activeSortButton.dataset.sortType;
        var prom = this.GetSearchResults(pageNo, this.newsRootId, sortType);
        prom.then(
            function (result) {
                //   console.log("Processing ajax results : %o", result);

                $('#nextPageOfResults').html(result.htmlResults);

                this.DoPagination(result.totalResultCount, pageNo);

                document.getElementById("topOfSearch").scrollIntoView();
            }.bind(this)
        );
    },

    GetSearchResults: function (pageNo, rootNode, sortType) {
        var newsResultsContainer = document.getElementById("nextPageOfResults");
        newsResultsContainer.setAttribute("aria-busy", "true");

        return new Promise(function (resolve, reject) {

            //var searchParams = null;
            var paramSource = "";

            // If we have a cookie use that object to search and populate the form 
            if (this.initialSearch === "disabled" && Cookies.get(SearchType)) {
                // Get from cookie
                paramSource = "cookie";
                searchParams = JSON.parse(Cookies.get(SearchType));
                // default
                searchParams.rootNodeId = rootNode;
                var fn = window['this.populate' + SearchType];
                if (typeof fn === "function") {
                    fn(searchParams);
                } else {
                    console.error('Missing populate function %o so can\'t populate form', 'populate' + SearchType);
                }
            } else {
                // Default
                paramSource = "fields";
    
                searchParams = this.BuildSiteSearchParams(pageNo, sortType);
            }

            // console.log('GetSearchResults with %o searchParams : %o', paramSource, searchParams);
            this.initialSearch = false;

            fetch('/umbraco/surface/NewsSearch/DoNewsSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    // console.log('response : %o', response.json());
                    resolve(response.json());
                    newsResultsContainer.setAttribute("aria-busy", "false");
                })
                .catch(error => {
                    newsResultsContainer.setAttribute("aria-busy", "false");
                    console.log('Failed', error);
                    reject(error);
                });
        }.bind(this));
    },

    FilterToArray: function (collection) {
        var result = new Array();
        var length = collection.length;

        for (var j = 0; j < length; j++) {
            result.push($(collection[j]).val());
        }

        return result;
    },

    BuildSiteSearchParams: function (pageNo, sortType) {
        searchParams = {};
        searchParams.currentResultPage = pageNo;

        searchParams.partialView = this.renderPartial;

        // Keywords
        if ($('#searchFieldInput').val() !== '') {
            searchParams.keywords = $('#searchFieldInput').val();
        }

        // Specific doc type(s) - Can be used to create a news or event only listing
        if ($('#searchSpecificDocType').val() !== '') {
            searchParams.searchSpecificDocType = $('#searchSpecificDocType').val();
        }


        // content type : "content" or "media"  - (empty = both)
        if ($('#searchContentType').val() !== null && $('#searchContentType').val() !== '') {
            searchParams.contentTypeCorM = $('#searchContentType').val();
        }

        // Root node restriction . e.g. publications only look in the archive folder
        //var rnv = $('#rootNode').val();
        //if (rnv !== null && rnv !== '' && rnv !== undefined) {
        //    searchParams.rootNodeId = $('#rootNode').val();
        //    console.log(searchParams.rootNodeId);
        //}

        // To handle multiple news listing pages
        if (this.newsRootId !== 0) {
            searchParams.rootNode = this.newsRootId;
        }

        // Date filter target field
        if ($('#dateFilterField').val() !== null && $('#dateFilterField').val() !== '') {
            searchParams.dateFilterField = $('#dateFilterField').val();
        }

        // Results order
        searchParams.orderField = sortType;
        //if ($('#orderField').val() !== null && $('#orderField').val() !== '') {
        //    searchParams.orderField = $('#orderField').val();
        //}

        // Results per page
        //if ($('#resultsPerPage').val() !== null && $('#resultsPerPage').val() !== '') {
        //    searchParams.resultsPerPage = $('#resultsPerPage').val();
        //}
        searchParams.resultsPerPage = this.itemsPerPage;

        /// =================================
        /// Custom taxonomy
        /// =================================

        // People
        var checks = $("input[type='checkbox'][data-group='people']");
        if (checks.length) {
            searchParams.people = nodeListToIds(checks);
        }

        var customFilterCheckboxes = document.querySelectorAll(".customFilter");
        if (customFilterCheckboxes.length) {
            searchParams.customFilters = nodeListToIds(customFilterCheckboxes);
        }


        if (!isEmptyOrSpaces($('#startDate').val()) && !isEmptyOrSpaces($('#endDate').val())) {
            searchParams.startDate = $('#startDate').val();
            searchParams.endDate = $('#endDate').val();
        }

        // fallback image
        searchParams.fallbackImageId = this.fallbackImageId.toString();


        // Save a cookie
        if (this.SearchType === "") {
            console.log('Search type not set so no cookie name available');
        } else {
            //  console.log('Setting %o cookie to %o', this.SearchType, searchParams);
            Cookies.set(this.SearchType, searchParams, {
                //expires: 1 - Session cookie
            });
        }

        return searchParams;
    }
}



var newsFilterButtons = document.querySelectorAll(".newsFilter");

if (newsFilterButtons) {
    newsFilterButtons.forEach((filterButton) => {
        filterButton.addEventListener("click", handleNewsFilterButton);
    })
}

function handleNewsFilterButton(e) {
    var expanded = e.target.getAttribute("aria-expanded");
    if (expanded === "true") {
        e.target.setAttribute("aria-expanded", "false");
    } else {
        e.target.setAttribute("aria-expanded", "true");
    }
}

